var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPackage = function SvgPackage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#222222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69772 8.18036L11.3131 5.51744C11.7386 5.27202 12.2614 5.27202 12.6869 5.51744L17.3023 8.18036C17.3805 8.22525 17.3692 8.33549 17.2878 8.3744L12.6471 10.5936C12.2379 10.7893 11.7621 10.7893 11.3529 10.5936L6.71221 8.3744C6.63084 8.33549 6.61949 8.22525 6.69772 8.18036Z",
    fill: "#01cdfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4615 12.659C12.4615 12.0813 12.7933 11.555 13.3144 11.3058L17.8561 9.13381C17.9119 9.10713 17.9781 9.13934 17.9868 9.20057C17.9955 9.26427 18 9.32889 18 9.39411V14.686C18 15.1877 17.7338 15.651 17.3023 15.8997L12.6869 18.5626C12.5819 18.6231 12.4615 18.5393 12.4615 18.4181V12.659Z",
    fill: "#01cdfb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6856 11.3058C11.2067 11.555 11.5385 12.0813 11.5385 12.659V18.4181C11.5385 18.5393 11.4181 18.6231 11.3131 18.5626L6.69772 15.8997C6.26623 15.651 6 15.1877 6 14.686V9.39411C6 9.23279 6.17354 9.14797 6.31907 9.21757L10.6856 11.3058Z",
    fill: "#01cdfb"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPackage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/package.3617ab59.svg";
export { ForwardRef as ReactComponent };